import { Stack } from '@mui/material'
import { memo } from 'react'

import ProviderIcon from '../shared/exchangeProviderCard/ProviderIcon'
import Text from '../shared/text/Text'

const DisplayBadge = ({
  id,
  name,
  size = 'sm',
  direction = 'column',
  icon,
  separator = '',
  iconStyles
}) => {
  const iconProps = icon ? { icon } : { src: `/assets/tiers/${id}-s.png` }
  return (
    <Stack spacing={0.5} direction={direction} alignItems='center'>
      <ProviderIcon
        size={size === 'xs' ? 23 : 40}
        sx={{ mx: 'auto', ...iconStyles }}
        {...iconProps}
      />
      <Text variant='subtitle2' label={name} /> {separator}
    </Stack>
  )
}

export default memo(DisplayBadge)
